"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInactivityContext = exports.InactivityContextProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _sweetalert = _interopRequireDefault(require("sweetalert2"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _dmsbasereact = require("dmsbasereact");
var _userInteractionToken = require("dmsbasereact/src/functions/userInteractionToken");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// InactivityContext.js

// Context that exposes pause/resume
const InactivityContext = /*#__PURE__*/(0, _react.createContext)({
  pauseTimer: () => {},
  resumeTimer: () => {}
});
const InactivityContextProvider = _ref => {
  var _ref2;
  let {
    children
  } = _ref;
  const navigate = (0, _reactRouterDom.useNavigate)();
  const timeoutRef = (0, _react.useRef)(null);
  const countdownRef = (0, _react.useRef)(null);
  const pausedRef = (0, _react.useRef)(false);
  const checkInterval = (_ref2 = localStorage.getItem(_dmsbasereact.LocalStorageVariables.InactivityTimer) * 1000) !== null && _ref2 !== void 0 ? _ref2 : -1;
  const logoutUser = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate(0);
  };

  // Show countdown modal
  const showCountdownSwal = () => {
    if (pausedRef.current) return;
    let timeLeft = 10;
    _sweetalert.default.fire({
      title: _reactIntlUniversal.default.get("InactivityWarning").d("Inactivity Warning"),
      html: _reactIntlUniversal.default.get("CountdownForLoggedOutWarning").d("You will be logged out in <b>".concat(timeLeft, "</b> seconds due to inactivity. Move the mouse to stay logged in.")),
      timer: timeLeft * 1000,
      timerProgressBar: true,
      didOpen: () => {
        _sweetalert.default.showLoading();
        const timeElement = _sweetalert.default.getHtmlContainer().querySelector("b");
        timeElement.textContent = timeLeft;
        countdownRef.current = setInterval(() => {
          timeLeft -= 1;
          timeElement.textContent = timeLeft;
        }, 1000);
      },
      willClose: () => clearInterval(countdownRef.current),
      customClass: {
        container: "inactivity-modal"
      }
    }).then(result => {
      if (result.dismiss === _sweetalert.default.DismissReason.timer) logoutUser();
    });
  };

  // Reset inactivity timer
  const resetTimer = () => {
    if (pausedRef.current) return;
    (0, _userInteractionToken.userInteractionToken)();
    clearTimeout(timeoutRef.current);
    clearInterval(countdownRef.current);
    const modal = document.querySelector(".swal2-container.inactivity-modal");
    if (modal) _sweetalert.default.close();
    timeoutRef.current = setTimeout(showCountdownSwal, checkInterval);
  };

  // Pause/resume
  const pauseTimer = () => {
    pausedRef.current = true;
    clearTimeout(timeoutRef.current);
    clearInterval(countdownRef.current);
    const modal = document.querySelector(".swal2-container.inactivity-modal");
    if (modal) _sweetalert.default.close();
  };
  const resumeTimer = () => {
    pausedRef.current = false;
    resetTimer();
  };

  // Effect to attach event listeners
  (0, _react.useEffect)(() => {
    if (checkInterval === -1) return;
    const events = ["mousedown", "mousemove", "keypress", "scroll", "touchstart"];
    events.forEach(event => window.addEventListener(event, resetTimer));
    resetTimer(); // start timer

    return () => {
      clearTimeout(timeoutRef.current);
      clearInterval(countdownRef.current);
      _sweetalert.default.close();
      events.forEach(event => window.removeEventListener(event, resetTimer));
    };
  }, [checkInterval, navigate]);
  return /*#__PURE__*/_react.default.createElement(InactivityContext.Provider, {
    value: {
      pauseTimer,
      resumeTimer
    }
  }, children);
};

// Hook to use in any page
exports.InactivityContextProvider = InactivityContextProvider;
const useInactivityContext = () => (0, _react.useContext)(InactivityContext);
exports.useInactivityContext = useInactivityContext;